import {
  getCompany,
  updateReseller,
  updateCompanyInfo,
  createCustomerInFortnox,
} from '../../api/admin';
import invalidationManager from './InvalidationManager';
import Company from '../../model/Company';

export const { hook: useGetCompany, fetcher: companyStore } = invalidationManager.createFetcher({
  queryKey: (companyId: string) => ['company', companyId],
  fetchFunction: async (companyId: string) => {
    return getCompany(companyId);
  },
});

export const useUpdateCompanyResellerMutation = invalidationManager.createMutationHook({
  mutationFunction: async (companyId: string, resellerId: string) => {
    await updateReseller(companyId, resellerId);
    await invalidationManager.invalidate(['company', companyId]);
  },
});

export const useUpdateCompanyInfoMutation = invalidationManager.createMutationHook({
  mutationFunction: async (companyId: string, companyData: Partial<Company>) => {
    await updateCompanyInfo(companyId, companyData);
    await invalidationManager.invalidate(['company', companyId]);
  },
});

export const useCreateCustomerInFortnoxMutation = invalidationManager.createMutationHook({
  mutationFunction: async (companyId: string) => {
    await createCustomerInFortnox(companyId);
    await invalidationManager.invalidate(['company', companyId]);
  },
});
